import { render, staticRenderFns } from "./transactions_report.vue?vue&type=template&id=5182a8c8"
import script from "./transactions_report.vue?vue&type=script&lang=js"
export * from "./transactions_report.vue?vue&type=script&lang=js"
import style0 from "./transactions_report.vue?vue&type=style&index=0&id=5182a8c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports